import { jsx as r, jsxs as m } from "react/jsx-runtime";
import * as i from "@radix-ui/react-radio-group";
import { forwardRef as u, useId as v } from "react";
import { c as s } from "./cn-DlLpp5ix.js";
const j = u(
  function({ orientation: o = "vertical", className: t, ...e }, a) {
    return /* @__PURE__ */ r(
      i.Root,
      {
        ref: a,
        orientation: o,
        className: s(
          "flex",
          o === "vertical" ? "flex-col gap-2" : "flex-row gap-4",
          t
        ),
        ...e
      }
    );
  }
), w = {
  sm: "h-4 w-4",
  md: "h-5 w-5"
}, I = {
  sm: "h-1.5 w-1.5",
  md: "h-2 w-2"
}, G = u(
  function({ size: o = "md", label: t, description: e, className: a, id: p, disabled: n, value: h, ...x }, b) {
    const g = v(), c = p ?? `radio-${g}`, d = e ? `${c}-description` : void 0, l = /* @__PURE__ */ r(
      i.Item,
      {
        ref: b,
        id: c,
        value: h,
        disabled: n,
        "aria-describedby": d,
        className: s(
          "inline-flex shrink-0 items-center justify-center rounded-full border transition-colors",
          "focus-visible:outline-none focus-visible:shadow-ring-focus",
          w[o],
          "border-strong bg-bg-base hover:border-accent",
          "data-[state=checked]:border-accent",
          "disabled:cursor-not-allowed disabled:opacity-60",
          a
        ),
        ...x,
        children: /* @__PURE__ */ r(i.Indicator, { className: "flex items-center justify-center", children: /* @__PURE__ */ r("span", { "aria-hidden": "true", className: s("rounded-full bg-accent", I[o]) }) })
      }
    );
    return !t && !e ? l : /* @__PURE__ */ m("div", { className: "flex items-start gap-2", children: [
      l,
      /* @__PURE__ */ m("div", { className: "flex flex-col gap-0.5", children: [
        t ? /* @__PURE__ */ r(
          "label",
          {
            htmlFor: c,
            className: s(
              "cursor-pointer text-sm font-medium text-primary",
              n && "cursor-not-allowed opacity-60"
            ),
            children: t
          }
        ) : null,
        e ? /* @__PURE__ */ r("p", { id: d, className: "text-xs text-secondary", children: e }) : null
      ] })
    ] });
  }
);
export {
  G as R,
  j as a
};
//# sourceMappingURL=Radio-QROHk7H_.js.map
